// extracted by mini-css-extract-plugin
module.exports = {"text":"UnderlineText_text__UUW8l"};